/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FinalizeDraftInstantConversationRequest
 */
export interface FinalizeDraftInstantConversationRequest {
    /**
     * 
     * @type {string}
     * @memberof FinalizeDraftInstantConversationRequest
     */
    draftConversationId: string;
    /**
     * The identityId of the client
     * @type {string}
     * @memberof FinalizeDraftInstantConversationRequest
     */
    clientIdentityId: string;
}

/**
 * Check if a given object implements the FinalizeDraftInstantConversationRequest interface.
 */
export function instanceOfFinalizeDraftInstantConversationRequest(value: object): value is FinalizeDraftInstantConversationRequest {
    if (!('draftConversationId' in value) || value['draftConversationId'] === undefined) return false;
    if (!('clientIdentityId' in value) || value['clientIdentityId'] === undefined) return false;
    return true;
}

export function FinalizeDraftInstantConversationRequestFromJSON(json: any): FinalizeDraftInstantConversationRequest {
    return FinalizeDraftInstantConversationRequestFromJSONTyped(json, false);
}

export function FinalizeDraftInstantConversationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FinalizeDraftInstantConversationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'draftConversationId': json['draftConversationId'],
        'clientIdentityId': json['clientIdentityId'],
    };
}

export function FinalizeDraftInstantConversationRequestToJSON(value?: FinalizeDraftInstantConversationRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'draftConversationId': value['draftConversationId'],
        'clientIdentityId': value['clientIdentityId'],
    };
}

